import axios from "axios";
import ApiMethods from "../js/api-methods"

const qs = require('qs');

export default class ErrorService {
  async saveError(query){
    try {
      let data = qs.stringify(query)
      axios.post(ApiMethods.SAVE_ERROR, data );

    } catch (e) {
      throw e
    }
  }

  async sendErrorOnEmail(query){
    try {
      let data = qs.stringify(query)
      axios.post(ApiMethods.SEND_ERROR_EMAIL, data );

    } catch (e) {
      throw e
    }
  }
}